import React from "react";
import PropTypes from "prop-types";
import { Typography } from "antd";

import {
  GRAY_50,
  GRAY_200,
  GRAY_600,
  GRAY_800,
  PRIMARY_500,
  SUCCESS_50,
  SUCCESS_200,
  SUCCESS_700
} from "../../constant/colors";

const { Text } = Typography;

/**
 * The opening statement of a HITL task: an icon, a headline, and a sentence of
 * plain-English context — "here is what we found, here is what happens next".
 *
 * Shared so every task type opens the same way. It began as the consent modal's
 * state panel; express enrollment adopted it rather than growing a lookalike,
 * because two panels drifting apart is exactly how a modal starts feeling like
 * two products.
 *
 * `goodNews` is the whole visual switch: green when the agent is reporting
 * something that went WELL (a patient it can help, an enrollment it prepared),
 * neutral grey when it is reporting a state the navigator has to weigh.
 */
export const TaskStatePanel = ({ icon: Icon, title, body, goodNews = false, "data-testid": dataTestId }) => (
  <div
    data-testid={dataTestId}
    style={{
      display: "flex",
      gap: 12,
      padding: 14,
      borderRadius: 8,
      border: `1px solid ${goodNews ? SUCCESS_200 : GRAY_200}`,
      background: goodNews ? SUCCESS_50 : GRAY_50
    }}
  >
    <Icon style={{ color: goodNews ? SUCCESS_700 : PRIMARY_500, fontSize: 20, flexShrink: 0, marginTop: 2 }} />
    <div>
      <Text strong style={{ display: "block", color: GRAY_800 }} data-testid={dataTestId && `${dataTestId}-title`}>
        {title}
      </Text>
      <Text style={{ display: "block", marginTop: 4, fontSize: 13, color: GRAY_600 }}>{body}</Text>
    </div>
  </div>
);

TaskStatePanel.propTypes = {
  /** antd icon component — the tone-setter, paired with `goodNews`. */
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.node.isRequired,
  body: PropTypes.node,
  goodNews: PropTypes.bool,
  "data-testid": PropTypes.string
};

export default TaskStatePanel;
